/* eslint-disable react-hooks/exhaustive-deps */
import { Input, Loader, Modal, Title } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { Phone, UserPlus, X } from 'tabler-icons-react';
import useFirebaseFunction from "../../utils/useFirebaseFunction";
import Button from '../Inputs/Button';

const MembersPanelModal = ({opened, setOpened, board}) => {

    const [add_moderator , isAddModeratorLoading] = useFirebaseFunction("add_moderator");
    const [get_board_moderators, isGetBoardModeratorsLoading] = useFirebaseFunction("get_board_moderators", "europe-west1");

    const [members, setMembers] = useState([]);
    const [phone,setPhone] = useState('');


    // todo: DE FACUT LOADING LA MEMBERS
    const getData = () => {
        get_board_moderators({board}).then(({data}) => {
            setMembers(data);
        });
    }

    const doAddPhoneNumber = () => {
        let clearPhone = phone.replace('-','').replace('-','').replace(/\s/g, '');
        const action = true;

        if(clearPhone.includes('_')){
            return;
        }

        add_moderator({board, phone:clearPhone, action}).then(getData);
    }
    
    const removePhoneNumber = (phone) => {
        const action = false;
        add_moderator({board,phone,action}).then(getData);
    }

    useEffect(() => {
       getData();
    }, [])

    return (
        <Modal
            centered={true}
            opened={opened}
            setOpened={setOpened}
            withCloseButton={true}
            lockScroll={true}
            onClose={() => setOpened(false)}
            className="mx-2"
            size={530}
        >
            <div className="w-full flex flex-col justify-center items-center">
                <div className="border-4 border-[rgb(46,46,46)] inline-flex rounded-full p-3 mb-2 justify-center items-center">
                    <UserPlus size={40} color="rgb(46,46,46)" />
                </div>
                <Title order={1} align='center' style={{color:'rgb(46,46,46)',fontWeight:'600',fontSize:'25px'}}>Gestionează Moderatorii Planșei</Title>
                <Title order={2} align='center' style={{color:'rgb(46,46,46)',fontWeight:'500',fontSize:'14px'}}>Permite editarea planșei de către alte persoane</Title>
                <div className="flex max-w-[350px] mt-8 w-full bg-white border pl-4 border-mainBlue rounded-md justify-between items-center">
                    <Input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        variant="unstyled"
                        component={InputMask} 
                        mask="+40 999-999-999" 
                        placeholder="+40 ___-___-___" 
                    />
                    <Button
                        disabled={phone.replace('-','').replace('-','').replace(/\s/g, '').includes('_') || phone.length === 0}
                        style={{lineHeight:'1.5',borderTopRightRadius:'0.2rem',borderBottomRightRadius:'0.2rem', borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px',fontSize:'14px',paddingLeft:'1.5rem',paddingRight:'1.5rem'}} 
                        label="Adauga" 
                        onClick={() => doAddPhoneNumber()} 
                        loading={isAddModeratorLoading} 
                    />
                </div>
                {!isGetBoardModeratorsLoading ? 
                    <div className="w-full max-w-[350px] mt-8">
                        {members.length > 0 && <Title order={2} align='left' style={{color:'rgb(46,46,46)',fontWeight:'700',fontSize:'18px'}} >Persoanele cu acces</Title>}
                        <div className="flex flex-col w-full gap-y-2 mt-3">
                            {members.map((item,index) => (
                                <div className="py-2 flex items-center justify-between" key={item.uid}>
                                    <div className="flex items-center gap-x-2">
                                        <Phone />
                                        <span className="font-bold text-[rgb(46,46,46)]">{item.phone}</span>
                                    </div>
                                    <X className="cursor-pointer" onClick={() => removePhoneNumber(item.phone)} />
                                </div>
                            ))}
                        </div>
                    </div>
                :
                    <div className="flex justify-center items-center w-full max-w-[350px] mt-8">
                        <Loader />
                    </div>
                }
            </div>
        </Modal>
    )
}

export default MembersPanelModal